var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.2078 0.558871C8.35392 0.480899 8.52918 0.480349 8.67579 0.557405L16.2326 4.52904C16.397 4.61545 16.5 4.78589 16.5 4.97163V13.0284C16.5 13.2141 16.397 13.3846 16.2326 13.471L8.67579 17.4426C8.52918 17.5196 8.35392 17.5191 8.2078 17.4411L0.764618 13.4695C0.601735 13.3826 0.5 13.213 0.5 13.0284V4.97163C0.5 4.78701 0.601735 4.61741 0.764617 4.5305L8.2078 0.558871ZM8.44495 1.56578L2.04484 4.98084L4.725 6.47225L11.1589 2.99216L8.44495 1.56578ZM12.225 3.55245L5.76105 7.04877L8.44501 8.54229L14.9428 4.98087L12.225 3.55245ZM15.5 5.81585L8.94318 9.4096V16.1724L15.5 12.7263V5.81585ZM7.94318 16.1665V9.40744L1.5 5.82206V12.7285L7.94318 16.1665Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderIcon);
export default __webpack_public_path__ + "static/media/order-icon.494caf511bbba7cca8b57196c348a14d.svg";
export { ForwardRef as ReactComponent };